import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";

const ServicesFetureSectionForHome = () => {


  const [items, setItems] = useState([]);
  const [service, setService] = useState([]);


  const [page, setPage] = useState([]);
  const { pageSlug } = useParams(); // Extract the blog post titleSlug from the URL


  useEffect(() => {
    fetch(`https://healthkeywordresearch01-5ec078e699df.herokuapp.com/page/${pageSlug}`)
      .then((res) => res.json())
      .then((info) => setPage(info))
      .catch((error) => console.error("Error fetching banners:", error));
  }, []);


  useEffect(() => {
    fetch(`https://healthkeywordresearch01-5ec078e699df.herokuapp.com/featureitems`)
      .then((res) => res.json())
      .then((info) => setItems(info));
  }, []);


  useEffect(() => {
    fetch(`https://healthkeywordresearch01-5ec078e699df.herokuapp.com/featurestext`)
      .then((res) => res.json())
      .then((info) => setService(info));
  }, []);


  return (


    <><section
      id="services-5"
      className="services-5 bg-lightgrey wide-70 services-section division"
    >
      <div className="container">
        {/* SECTION TITLE */}
        <div className="row">
          <div className="col-lg-10 offset-lg-1">
            {
              service.map(e => e.pageSlug === '' && <div className="section-title mb-60 text-center">
                {/* Title 	*/}
                <h3 className="h3-md">{e.FeaturesHeading}</h3>
                {/* Text */}
                <p className="p-lg">
                  {e.FeaturesText}
                </p>
              </div>)}

          </div>
        </div>
        {/* SERVICES-5 WRAPPER */}
        <div className="sbox-5-wrapper pc-05">
          <div className="row grey-color">
            {
              items.map(b => b.pageSlug === '' && <div className="col-md-6">
                <div
                  className="sbox-5 d-flex align-items-center wow fadeInUp"
                  data-wow-delay="0.4s"
                >
                  {/* Icon */}
                  <div className="sbox-5-ico">
                    <img
                      className="img-60"
                      src={b.FeaturesIcon}
                      alt="service-icon"
                    />
                  </div>
                  {/* Text */}
                  <div className="sbox-5-txt">
                    <h4 className="h6-lg">
                    {b.FeaturesText}
                    </h4>
                    <h6 className="h6-lg">
                    {b.FeaturesDesc}
                    </h6>
                  </div>
                </div>
              </div>)}







          </div>{" "}
          {/* End row */}
        </div>{" "}
        {/* END SERVICES-5 WRAPPER */}
      </div>{" "}
      {/* End container */}
    </section>
    </>

  );
};

export default ServicesFetureSectionForHome;
